define('view/form.answer.page.view',['require','exports','module','underscore','jquery','backbone','blockit','formkit/formkit','uikit/uikit','fukit','backbone.radio','fukit','fukit','fukit','fukit','fukit','view/disclosure/disclosure.modals','model/provisional.organization.model'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      $        = require('jquery'),
      Backbone = require('backbone'),
      BlocKit  = require('blockit'),
      FormKit  = require('formkit/formkit'),
      UIKit    = require('uikit/uikit'),
      FuKit    = require('fukit'),
      Radio    = require('backbone.radio'),
      ROLES    = require('fukit').Roles,
      config   = require('fukit').config;

      //Behaviors
      EnableLoadingOnModelRequestBehavior = require('fukit').EnableLoadingOnModelRequestBehavior,
      EnableOnlyOnUnsavedChangesBehavior  = require('fukit').EnableOnlyOnUnsavedChangesBehavior,
      AuthorizationBehavior               = require('fukit').AuthorizationBehavior,

      //modals
      DisclosureModals             = require('view/disclosure/disclosure.modals'),
      ProvisionalOrganizationModel = require('model/provisional.organization.model');

      //Radio channels
      UIChannel = Radio.channel('UIChannel');

  var ManualChangesHelper = Backbone.Model.extend({
    enableChanges: function() {
      this.set('changes', true);
      return this;
    },

    disableChanges: function() {
      this.set('changes', false);
      return this;
    },

    hasChanges: function() {
      return this.get('changes');
    },
  });

  var PAGE_DEFAULTS = {
    DISTINCT_VALUE_ATTRIBUTE: 'content',
  };

  var FormAnswerPageView = BlocKit.ResolveOptionsView.extend({
    changesHelper: new ManualChangesHelper(),

    resolveOptions: {
      modals: DisclosureModals,
      root: {
        type: BlocKit.TwoColumnLeftRailLayoutView,

        behaviors: {
          AnswerFormRootBehavior: {
            form: '@this.form',
            behaviorClass: FormKit.Block.AnswerFormRootBehavior,
          },
          AnswerBehavior: {
            form: '@this.form',
            changesHelper: '@this.changesHelper',
            answerCollection: '@resources.documentAnswers',
            saveDebounceTime: 5,
            onSaveStart: function() {
              this.getOption('changesHelper').enableChanges();
            },
            onSaveComplete: function() {
              this.getOption('changesHelper').disableChanges();
            },
            behaviorClass: FormKit.AnswerSaveBehavior,
          },
        },

        pageHeader: {
          headerText: 'Profile',
          breadcrumbs: [
            {
              text: 'Profile',
            },
            {
              text: 'Current User',
              link: '',
              behaviors: {
                updateCrumbWithPersonNameBehavior: {
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  optionValues: {
                    link: {
                      formatter: function() {
                        var collection = Radio.request(
                          'AppKit.resourceService',
                          'resource',
                          'nonProvisionableProductCollection'
                        );
                        if (collection) {
                          return collection.findWhere({ name: 'PROFILE' }).get('path') + '#name';
                        }
                        return '';
                      },
                    },
                    text: {
                      formatter: function() {
                        var personPrincipalModel = Radio.request(
                          'AppKit.resourceService',
                          'resource',
                          'personPrincipalModel'
                        );
                        var displayName = 'Current User';

                        if (personPrincipalModel) {
                          var fullName = personPrincipalModel.get('fullName');
                          var username = personPrincipalModel.get('username');

                          if (fullName && fullName.trim().length > 0) {
                            displayName = fullName;
                          } else if (username && username.length > 0) {
                            displayName = username;
                          }
                        }

                        return displayName;
                      },
                    },
                  },
                },
              },
            },
            {
              text: 'COI Disclosures',
              link: '',
              behaviors: {
                updateCrumbWithPersonNameBehavior: {
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  optionValues: {
                    link: {
                      formatter: function() {
                        var collection = Radio.request(
                          'AppKit.resourceService',
                          'resource',
                          'nonProvisionableProductCollection'
                        );
                        if (collection) {
                          /* The next few lines support local development by setting the target URL to the PROFILE_URL
                             parameter defined in config/app-development.yml. This allows the profile-page app to be
                             accessed when it is running locally, for example at localhost:9002.
                           */
                          var profilePage = collection.findWhere({ name: 'PROFILE' }).get('path') + '#disclosures';
                          if (config.get('PROFILE_URL')) {
                            profilePage = config.get('PROFILE_URL');
                          }
                          return profilePage;
                        }
                        return '';
                      },
                    },
                  },
                },
              },
            },
            {
              text: 'Disclosure Form',
            },
          ],
          actions: [
            {
              name: 'saveButtonView',
              text: 'Save',
              icon: 'save',
              color: 'primary',
              model: '@resources.template',
              changesHelper: '@this.changesHelper',
              behaviors: {
                EnableOnlyOnUnsavedChanges: {
                  behaviorClass: EnableOnlyOnUnsavedChangesBehavior,
                },
                EnableLoadingOnModelRequest: {
                  behaviorClass: EnableLoadingOnModelRequestBehavior,
                },
              },
            },
            // Create disclosure submit button
            {
              type: UIKit.Button.extend({
                initialize: function() {
                  var saveButtonView = this;

                  this.on('press', function() {
                    this.disabled = true;
                    this.loading = true;
                  });

                  UIChannel.reply('create:submit:enable', function() {
                    saveButtonView.disabled = false;
                    saveButtonView.loading = false;

                    return saveButtonView;
                  })

                  UIKit.Button.prototype.initialize.apply(this,arguments);
                }
              }),
              color: 'primary',
              text: 'Submit',
              icon: 'send',
              model: '@resources.disclosure',
              routingActionCollection: '@resources.disclosure.workflowTaskModel.formDataModel.routingActionCollection',
              behaviors: {
                ConfirmInvokeModelMethodOnEventBehavior: {
                  method: 'completeTaskWithRoutingAction',
                  methodArguments: function() {
                    var routingActionCollection = this.view.getOption('routingActionCollection');
                    var routingAction = routingActionCollection.findWhere({ routingId: 'SUBMIT' });
                    var formHeight = $('[data-ui-name="contentColumnView"]').height() + 100 || 5000;  // setting the fallback value to be REALLY tall in case something borks

                    // Per COI-1582, wait 1500ms before attempting to show the modal
                    var overlayTimeoutId = window.setTimeout(function() {
                      $('#coiWaitMessage').height(formHeight).removeClass('hidden');
                      UIChannel.request('start:waitmessage:rotation');
                    }, 1500);

                    UIChannel.reply('fetch:overlay:timeout', function() {
                      return overlayTimeoutId;
                    });

                    return [routingAction];
                  },
                  targetModel: '@resources.disclosure.workflowTaskModel',
                  onMethodSuccess: function() {
                    this.view.trigger('task:completed');
                  },
                  onMethodError: function(model, resp) {
                    var respCode = resp && resp.status ? resp.status : null;

                    if (respCode === 504) {
                      // continue processing the request as if the task has completed
                      this.view.trigger('task:completed')
                    }

                    UIChannel.request('proposal:ui:reset');
                  },
                  modalOptions: {
                    closable: true,
                    header: {
                      text: 'Routing Confirmation',
                    },
                    content: {
                      text: 'Are you sure you want to route your disclosure?',
                    },
                    actions: {
                      confirmButton: {
                        text: 'Proceed',
                      },
                    },
                  },
                  behaviorClass: BlocKit.ConfirmInvokeModelMethodOnEventBehavior.extend({
                    onEvent: function() {
                      this.eventArgs = _.toArray(arguments);

                      //prettier-ignore
                      var args                = arguments,
                          onConfirm           = this.getOption('onConfirm'),
                          confirmModalOptions = Mn._getValue(this.getOption('modalOptions') || this.getOption('confirmModalOptions'), this);

                      this.createConfirmModal(_.extend({ visible: true, type: FuKit.ConfirmModalView }, confirmModalOptions))
                      .on('confirm', function() {
                        if (onConfirm) {
                          onConfirm.call(this, this.getTargetModel());
                        }
                        this.invokeModelMethod.apply(this, args);
                      }, this)
                      .on('deny modal:hide', function() {
                        UIChannel.request('create:submit:enable');
                      }, this);
                    },
                  }),
                },
                BindAndFormatOptionValuesBehavior: {
                  optionValues: {
                    disabled: {
                      model: '@resources.template',
                      modelAttribute: 'isValid',
                      formatter: function(isValid) {
                        // NOTE TO Aleksey: When you use the model and modelAttribute property as above, the formatter argument
                        // is value of the attribute, so in this case the value of the attribute "isValid"
                        // If the form is valid,we want to enable the "Submit" button, otherwise we disable it

                        return this.view.disabled = !isValid;

                      },
                    },
                    //In case notification failed at coi-workflow and process didn't move from "Create Disclosure"('CREATE')
                    // task to "Edit and Submit Disclosure"('SUBMIT'). Button will be visible, but disabled unless logic above
                    // will enable it.
                    visible: {
                      resource: '@resources.disclosure.workflowTaskModel.formDataModel.routingActionCollection',
                      formatter: function(resource) {
                        var routingAction_2 = resource.findWhere({ routingId: 'SUBMIT' });
                        var routingAction_1 = resource.findWhere({ routingId: 'CREATE' });
                        if (routingAction_2  || routingAction_1) {
                          return true;
                        }
                        return false;
                      },
                    },
                  },
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                },
                NavigateOnEventBehavior: {
                  eventName: 'task:completed',
                  routeName: 'disclosure:list',
                  profilePath: '/profile#disclosures',
                  routeParams: { primaryId: '@state.primaryId' },
                  returnToProfile: false,
                  behaviorClass: BlocKit.NavigateOnEventBehavior.extend({
                    //override the base NavigateOnEventBehavior to allow conditional routing
                    initialize: function() {
                      this.listenTo(this.view, this.getOption('eventName'), this.onEvent);

                      // If we have a 'disclosee' parameter in our route, it means we originated from the
                      // profile page (ie, a disclosee has submitted a disclosure). We should route the user
                      // back to their profile when they submit
                      if (location.hash.indexOf('/disclosee') !== -1) {
                        this.options['returnToProfile'] = true;
                      }
                    },
                    onEvent: function() {
                      var orgModel = new ProvisionalOrganizationModel();
                      var disclosureId = Radio.request('AppKit.resourceService', 'resource', 'disclosure').get('id');
                      orgModel.urlParams({ disclosureId: disclosureId });
                      orgModel.saveSubmittedExternalOrg();

                      $('#coiWaitMessage').addClass('hidden');
                      UIChannel.request('create:submit:enable');

                      this.eventArgs = _.toArray(arguments);
                      if (this.getOption('returnToProfile')) {
                        this.returnToProfile();
                      } else {
                        this.navigate();
                      }
                    },
                    returnToProfile: function() {
                      /* The next few lines support local development by setting the target URL to the PROFILE_URL
                         parameter defined in config/app-development.yml. This allows the profile-page app to be
                         accessed when it is running locally, for example at localhost:9002.
                       */
                      var PROFILE_URL = location.origin + this.getOption('profilePath');
                      if (config.get('PROFILE_URL')) {
                        PROFILE_URL = config.get('PROFILE_URL');
                      }
                      location.assign(PROFILE_URL);
                    },
                  }),
                },
              },
            },

            // Modify Disclosure Submit Button
            {
              type: UIKit.Button.extend({
                initialize: function() {
                  var saveButtonView = this;

                  this.on('press', function() {
                    this.disabled = true;
                    this.loading = true;
                  });

                  UIChannel.reply('modify:submit:enable', function() {
                    saveButtonView.disabled = false;
                    saveButtonView.loading = false;

                    return saveButtonView;
                  });

                  UIChannel.reply('trigger:completed:task', function() {
                    saveButtonView.trigger('task:completed');
                  })

                  UIKit.Button.prototype.initialize.apply(this,arguments);
                }
              }),
              color: 'primary',
              text: 'Submit',
              icon: 'send',
              model: '@resources.disclosure',
              routingActionCollection: '@resources.disclosure.workflowTaskModel.formDataModel.routingActionCollection',
              behaviors: {
                BindAndFormatOptionValuesBehavior: {
                  optionValues: {
                    disabled: {
                      model: '@resources.template',
                      modelAttribute: 'isValid',
                      formatter: function(isValid) {
                        // NOTE TO Aleksey: When you use the model and modelAttribute property as above, the formatter argument
                        // is value of the attribute, so in this case the value of the attribute "isValid"
                        // If the form is valid,we want to enable the "Submit" button, otherwise we disable it

                        return this.view.disabled = !isValid;
                      },
                    },
                    visible: {
                      resource: '@resources.disclosure.workflowTaskModel.formDataModel.routingActionCollection',
                      formatter: function(resource) {
                        routingAction = resource.findWhere({ routingId: 'SUBMIT_MODIFY' });

                        if (!routingAction) {
                          return false;
                        }
                        return true;
                      },
                    },
                  },
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                },
                NavigateOnEventBehavior: {
                  eventName: 'task:completed',
                  routeName: 'disclosure:list',
                  profilePath: '/profile#disclosures',
                  routeParams: { primaryId: '@state.primaryId' },
                  returnToProfile: false,
                  behaviorClass: BlocKit.NavigateOnEventBehavior.extend({
                    //override the base NavigateOnEventBehavior to allow conditional routing
                    initialize: function() {
                      this.listenTo(this.view, this.getOption('eventName'), this.onEvent);
                      // if we have a 'disclosee' parameter in our route, it means we originated from the
                      // profile page (ie, a disclosee has submitted a disclosure). We should route the user
                      // back to their profile when they submit
                      if (location.hash.indexOf('/disclosee') !== -1) {
                        this.options['returnToProfile'] = true;
                      }
                    },
                    onEvent: function() {
                      this.eventArgs = _.toArray(arguments);
                      if (this.getOption('returnToProfile')) {
                        this.returnToProfile();
                      } else {
                        this.navigate();
                      }
                    },
                    returnToProfile: function() {
                      /* The next few lines support local development by setting the target URL to the PROFILE_URL
                         parameter defined in config/app-development.yml. This allows the profile-page app to be
                         accessed when it is running locally, for example at localhost:9002.
                       */
                      var PROFILE_URL = location.origin + this.getOption('profilePath');
                      if (config.get('PROFILE_URL')) {
                        PROFILE_URL = config.get('PROFILE_URL');
                      }
                      location.assign(PROFILE_URL);
                    },
                  }),
                },
                ShowModalOnConfirmEventBehavior: {
                  eventName: 'press',
                  modalName: 'reasonForModificationModal',
                  behaviorClass: BlocKit.ShowModalOnEventBehavior,
                  onModalConfirm: function() {
                    var formHeight = $('[data-ui-name="contentColumnView"]').height() + 100 || 5000;  // setting the fallback value to be REALLY tall in case something borks
                    // Per COI-1582, wait 1500ms before attempting to show the modal
                    var overlayTimeoutId = window.setTimeout(function() {
                      $('#coiWaitMessage').height(formHeight).removeClass('hidden');
                      UIChannel.reply('start:waitmessage:rotation');
                    }, 1500);

                    UIChannel.reply('fetch:overlay:timeout', function() {
                      return overlayTimeoutId;
                    });
                  },
                  onModalDeny: function() {
                    UIChannel.request('modify:submit:enable');
                  },
                  onModalHide: function() {
                    UIChannel.request('modify:submit:enable');
                  }
                },
              },
            },
          ],
        },

        contentColumn: {
          components: [
            {
              type: BlocKit.ContentActionsHeaderView,
              header: {
                model: '@resources.templateType',
                behaviors: {
                  BindTextToActiveSectionTitleBehavior: {
                    form: '@this.form',
                    optionName: 'text',
                    bindValueToSectionAttribute: 'text',
                    behaviorClass: FormKit.BindOptionToActiveSectionChangeBehavior,
                  },
                },
              },
              actions: {
                components: [
                  {
                    text: 'Previous',
                    behaviors: {
                      GoToPreviousSectionBehavior: {
                        behaviorClass: FormKit.GoToPreviousSectionBehavior,
                        form: '@this.form',
                      },
                    },
                  },
                  {
                    text: 'Next',
                    behaviors: {
                      GoToNextSectionBehavior: {
                        behaviorClass: FormKit.GoToNextSectionBehavior,
                        form: '@this.form',
                      },
                    },
                  },
                ],
              },
            },
            {
              type: FormKit.Block.AnswerFormObjectCollectionView.extend({
                initialize: function() {
                  // This is an icky way to do this
                  this.on('childview:render:empty', function(view) {
                    var $waitMessageView = view.$el.clone().addClass('waitMessage hidden');

                    $waitMessageView.attr('id', 'coiWaitMessage');
                    $waitMessageView.find('.mainText').text('Your Disclosure is being submitted.');
                    $waitMessageView.find('.muted').text('Please don’t navigate away or close this window.');
                    $waitMessageView.find('.loading-text').remove();
                    $waitMessageView.find('.muted').after('<span id="rotatingText" class="muted">Thank you for your patience as it enters the review workflow.</span>');

                    _.defer(function() {
                      var $pageHeaderView = $('[data-ui-name="pageHeaderView"]');

                      if ($pageHeaderView.length > 0 && $('#coiWaitMessage').length === 0) {
                        $pageHeaderView.after($waitMessageView);
                      }
                    });
                  });

                  UIChannel.reply('start:waitmessage:rotation', function() {
                    var rotationMessages = [
                      "We're still here and still processing your request.",
                      "Still working on it.",
                      "We haven't forgotten about you.",
                      "It's still taking some time, but we're on it.",
                      "We're continuing to work on this.",
                      "Still working.",
                      "Don't worry. We're still working on it.",
                      "I promise we're still here and working on your request.",
                      "We're still at it! Maybe stretch your legs while you wait?"
                    ];
                    var rotationIndex = 0;

                    window.setInterval(function() {
                      if (rotationIndex === rotationMessages.length) {
                        rotationIndex = 0;
                      }

                      $('#rotatingText')
                        .fadeOut(500)
                        .text(rotationMessages[rotationIndex++])
                        .fadeIn(500);
                    }, 20000);
                  });

                  UIChannel.reply('proposal:ui:reset', function() {
                    var overlayTimeoutId = UIChannel.request('fetch:overlay:timeout');

                    // if the overlay hasn't fired yet, stop it before it does
                    window.clearTimeout(overlayTimeoutId);

                    $('#coiWaitMessage').addClass('hidden');
                    UIChannel.request('create:submit:enable');
                    UIChannel.request('modify:submit:enable');
                  });

                  FormKit.Block.AnswerFormObjectCollectionView.prototype.initialize.apply(this, arguments);
                },
              }),
              form: '@this.form',
              childViewOptions: {
                childViewOptions: {
                  top: function() {
                    return {
                      actions: {},
                    };
                  },
                },
              },
              behaviors: {
                BindAndFormatOptionValuesBehavior: {
                  optionValues: {
                    readonly: {
                      modelAttribute: 'canEdit',
                      model: '@resources.formPermissionModel',
                      formatter: BlocKit.Formatter.invert(),
                    },
                  },
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                },
              },
            },
          ],
        },

        railColumn: {
          components: [
            {
              type: FormKit.Block.AnswerSectionMenuView,
              form: '@this.form',
            },
          ],
        },
      },
    },
  });

  module.exports = FormAnswerPageView;
});

